module.exports = __webpack_public_path__ + "img/collection-weddingRingsModern@2x.dfd89e2.jpg";